module.exports = __webpack_public_path__ + "03_medium_grey.8120c862.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/03_medium_grey.png
// module id = MF/z
// module chunks = 0